<template>
  <div class="wiki_share_guide" v-if="showModelVisible" @click="handleClose">
    <div class="wiki_dialog_model">
      <div class="wiki_dialog_header">
        <div class="tab">
          <div class="tab-item active">海报</div>
          <div class="tab-item">整页截图</div>
        </div>
      </div>
      <div class="wiki_dialog_body">
        <img class="wiki_dialog_body_img" :src="imgURL" alt="">
      </div>
      <div class="wiki_dialog_footer">
        <div class="bottom">
          <button class="btn">保存图片</button>
          <button class="btn btn_model" style="visibility: hidden">复制链接分享</button>
        </div>
      </div>
      <img src="../../../../assets/images/share_guide_1.png" alt="" class="share_guide_1">
      <img src="../../../../assets/images/share_guide_2.png" alt="" class="share_guide_2">
      <img src="../../../../assets/images/share_guide_3.png" alt="" class="share_guide_3">
      <img @click="handleClose" src="../../../../assets/images/share_guide_close.png" alt="" class="share_guide_close">
    </div>
  </div>
</template>
<script>
export default {
  name: "wiki_share_guide",
  props: {
    imgURL: {
      type: String,
      default: ''
    },
    showModelVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClose(e) {
      console.log(e.target.className)
      const classNames = ["tab-item active", 'tab-item', "wiki_dialog_body_img", "btn"]
      if (!classNames.includes(e.target.className)) {
        this.$emit('closeModel')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.wiki_share_guide {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;

  .wiki_dialog_model {
    margin-top: 15vh;
    width: 427px;
    height: 593px;
    border-radius: 12px;
    background: rgba(0, 0, 0, 0.4);
    position: absolute;


    .wiki_dialog_header {
      width: 100%;
      padding: 10px 16px;
      position: absolute;
      top: 53px;

      .tab {
        width: 388px;
        height: 42px;
        background: #dde5f4;
        border-radius: 21px;
        display: flex;
        align-items: center;
        padding: 0 4px;
        gap: 4px;

        .tab-item {
          width: 190px;
          height: 34px;
          line-height: 34px;
          text-align: center;
          font-weight: 400;
          font-size: 14px;
          color: #72818b;
          border-radius: 17px;

          &.active {
            background: #fff;
            border-radius: 17px;
            font-weight: 600;
            font-size: 14px;
            color: #51616f;
          }
        }
      }
    }

    .wiki_dialog_body {
      position: absolute;
      top: 117px;
      width: 427px;
      height: 395px;
      padding: 0 16px;
      box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.15);
      overflow: hidden;

      img {
        width: 389px;
      }
    }

    .wiki_dialog_footer {
      position: absolute;
      padding: 0;
      bottom: 0;
      width: 100%;
      border-radius: 0 0 12px 12px;

      .bottom {
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;

        .btn {
          width: 189px;
          height: 40px;
          background: #dbe2f0;
          border-radius: 20px;
          border: none;
        }

        .btn_model {
          background: #DBE2F0;
        }
      }
    }

    .share_guide_1 {
      position: absolute;
      left: -170px;
      top: 80px;
    }

    .share_guide_2 {
      position: absolute;
      right: -140px;
      top: 220px;
    }

    .share_guide_3 {
      position: absolute;
      bottom: -90px;
      left: -120px;
    }

    .share_guide_close {
      position: absolute;
      bottom: -150px;
      left: 190px;
      cursor: pointer;
    }
  }
}
</style>
